export const mutation_add_rischio = `
mutation addRischio($prestazioneId: Int!, $date: timestamp!, $spA1Livello: Int!, $spA1_1: Boolean!, $spA1_2: Boolean!, $spA1_3: Boolean!, $spA1_4: Boolean!, $spA1_5: Boolean!, $spA1_6: Boolean!, $spA1_7: Boolean!, $spA1Altro: Boolean!, $spA1AltroNote: String!, $spA2Altro: Boolean!, $spA2AltroNote: String!, $spA2Livello: Int!, $spA2_1: Boolean!, $spA2_2: Boolean!, $spA2_3: Boolean!, $spA3Altro: Boolean!, $spA3AltroNote: String!, $spA3Livello: Int!, $spA3_1: Boolean!, $spA3_2: Boolean!, $spA3_3: Boolean!, $spA3_4: Boolean!, $spA4Altro: Boolean!, $spA4AltroNote: String!, $spA4Livello: Int!, $spA4_1: Boolean!, $spA4_2: Boolean!,  $spA4_3: Boolean!, $spA4_4: Boolean!, $spASubTotale: numeric!, $spB1Livello: Int!, $spB1_1: Boolean!, $spB1_2: Boolean!, $spB1_3: Boolean!, $spB1_4: Boolean!, $spB1Altro: Boolean!, $spB1AltroNote: String!, $spB2Livello: Int!, $spB2_1: Boolean!, $spB2_2: Boolean!, $spB2_3: Boolean!, $spB2_4: Boolean!, $spB2Altro: Boolean!, $spB2AltroNote: String!, $spB3Livello: Int!, $spB3_1: Boolean!, $spB3_2: Boolean!,$spB3_3: Boolean!, $spB3Altro: Boolean!, $spB3AltroNote: String!, $spB4Livello: Int!, $spB4_1: Boolean!, $spB4_2: Boolean!, $spB4_3: Boolean!, $spB4Altro: Boolean!, $spB4AltroNote: String!, $spB5Livello: Int!, $spB5_1: Boolean!, $spB5_2: Boolean!, $spB5_3: Boolean!, $spB5Altro: Boolean!, $spB5AltroNote: String!, $spB6Livello: Int!, $spB6_1: Boolean!, $spB6_2: Boolean!, $spB6_3: Boolean!, $spB6_4: Boolean!, $spB6Altro: Boolean!, $spB6AltroNote: String!, $spB7Livello: Int!, $spBSubTotale: numeric!, $spC1_1_Livello: Int!, $spC1_2_Livello: Int!, $spC1_3_Livello: Int!, $spCSubTotale: numeric!, $efRiTotale: numeric!, $efSpTotale: numeric!, $efTotale: numeric!, $efAdeguataLivello: Int!, $providedBy: String!, $hasTabellaB: Boolean!, $dataControlloCostante: timestamp!, $hasTitEffPep : Boolean!) {
    insert_rischio_one(object: {PrestazioneId: $prestazioneId, Date: $date, SpA1Livello: $spA1Livello, SpA1_1: $spA1_1, SpA1_2: $spA1_2, SpA1_3: $spA1_3, SpA1_4: $spA1_4, SpA1_5: $spA1_5, SpA1_6: $spA1_6, SpA1_7: $spA1_7, SpA1Altro: $spA1Altro, SpA1AltroNote: $spA1AltroNote, SpA2Altro: $spA2Altro, SpA2AltroNote: $spA2AltroNote, SpA2Livello: $spA2Livello, SpA2_1: $spA2_1, SpA2_2: $spA2_2, SpA2_3: $spA2_3, SpA3Altro: $spA3Altro, SpA3AltroNote: $spA3AltroNote, SpA3Livello: $spA3Livello, SpA3_1: $spA3_1, SpA3_2: $spA3_2, SpA3_3: $spA3_3, SpA3_4: $spA3_4, SpA4Altro: $spA4Altro, SpA4AltroNote: $spA4AltroNote, SpA4Livello: $spA4Livello, SpA4_1: $spA4_1, SpA4_2: $spA4_2, SpA4_3: $spA4_3,SpA4_4: $spA4_4, SpASubTotale: $spASubTotale, SpB1Livello: $spB1Livello, SpB1_1: $spB1_1, SpB1_2: $spB1_2, SpB1_3: $spB1_3, SpB1_4: $spB1_4,  SpB1Altro: $spB1Altro, SpB1AltroNote: $spB1AltroNote, SpB2Livello: $spB2Livello, SpB2_1: $spB2_1, SpB2_2: $spB2_2, SpB2_3: $spB2_3, SpB2_4: $spB2_4, SpB2Altro: $spB2Altro, SpB2AltroNote: $spB2AltroNote, SpB3Livello: $spB3Livello, SpB3_1: $spB3_1, SpB3_2: $spB3_2,SpB3_3: $spB3_3, SpB3Altro: $spB3Altro, SpB3AltroNote: $spB3AltroNote, SpB4Livello: $spB4Livello, SpB4_1: $spB4_1, SpB4_2: $spB4_2,SpB4_3: $spB4_3, SpB4Altro: $spB4Altro, SpB4AltroNote: $spB4AltroNote, SpB5Livello: $spB5Livello, SpB5_1: $spB5_1, SpB5_2: $spB5_2, SpB5_3: $spB5_3, SpB5Altro: $spB5Altro, SpB5AltroNote: $spB5AltroNote, SpB6Livello: $spB6Livello, SpB6_1: $spB6_1, SpB6_2: $spB6_2, SpB6_3: $spB6_3,SpB6_4: $spB6_4, SpB6Altro: $spB6Altro, SpB6AltroNote: $spB6AltroNote, SpB7Livello: $spB7Livello, SpBSubTotale: $spBSubTotale, SpC1_1_Livello: $spC1_1_Livello, SpC1_2_Livello: $spC1_2_Livello, SpC1_3_Livello: $spC1_3_Livello, SpCSubTotale: $spCSubTotale, EfRiTotale: $efRiTotale, EfSpTotale: $efSpTotale, EfTotale: $efTotale, EfAdeguataLivello: $efAdeguataLivello, ProvidedBy: $providedBy, HasTabellaB: $hasTabellaB, DataControlloCostante: $dataControlloCostante, HasTitEffPep: $hasTitEffPep}) {
        Id
        PrestazioneId
        Date
        SpA1Livello
        SpA1_1
        SpA1_2
        SpA1_3
        SpA1_4
        SpA1_5
        SpA1_6
        SpA1_7
        SpA1Altro
        SpA1AltroNote
        SpA2Livello
        SpA2_1
        SpA2_2
        SpA2_3
        SpA2Altro
        SpA2AltroNote
        SpA3Livello
        SpA3_1
        SpA3_2
        SpA3_3
        SpA3_4
        SpA3Altro
        SpA3AltroNote
        SpA4Livello
        SpA4_1
        SpA4_2
        SpA4_3
        SpA4_4
        SpA4Altro
        SpA4AltroNote
        SpASubTotale
        SpB1Livello
        SpB1_1
        SpB1_2
        SpB1_3
        SpB1Altro
        SpB1AltroNote
        SpB2Livello
        SpB2_1
        SpB2_2
        SpB2_3
        SpB2_4
        SpB2Altro
        SpB2AltroNote
        SpB3Livello
        SpB3_1
        SpB3_2
        SpB3_3
        SpB3Altro
        SpB3AltroNote
        SpB4Livello
        SpB4_1
        SpB4_2
        SpB4_3
        SpB4Altro
        SpB4AltroNote
        SpB5Livello
        SpB5_1
        SpB5_2
        SpB5_3
        SpB5Altro
        SpB5AltroNote
        SpB6Livello
        SpB6_1
        SpB6_2
        SpB6_3
        SpB6_4
        SpB6Altro
        SpB6AltroNote
        SpB7Livello
        SpBSubTotale
        SpC1_1_Livello
        SpC1_2_Livello
        SpC1_3_Livello
        SpCSubTotale
        EfRiTotale
        EfSpTotale
        EfTotale
        EfAdeguataLivello
        ProvidedBy
        CreatedOn
        ModifiedOn
        HasTabellaB
        DataControlloCostante
        CreatedBy
        ModifiedBy
        HasTitEffPep
    }
}`;
export const mutation_update_rischio = `
mutation updateRischio($id: Int!, $prestazioneId: Int!, $date: timestamp!, $spA1Livello: Int!, $spA1_1: Boolean!, $spA1_2: Boolean!, $spA1_3: Boolean!, $spA1_4: Boolean!, $spA1_5: Boolean!, $spA1_6: Boolean!, $spA1_7: Boolean!, $spA1Altro: Boolean!, $spA1AltroNote: String!, $spA2Altro: Boolean!, $spA2AltroNote: String!, $spA2Livello: Int!, $spA2_1: Boolean!, $spA2_2: Boolean!, $spA2_3: Boolean!, $spA3Altro: Boolean!, $spA3AltroNote: String!, $spA3Livello: Int!, $spA3_1: Boolean!, $spA3_2: Boolean!, $spA3_3: Boolean!, $spA3_4: Boolean!, $spA4Altro: Boolean!, $spA4AltroNote: String!, $spA4Livello: Int!, $spA4_1: Boolean!, $spA4_2: Boolean!,  $spA4_3: Boolean!, $spA4_4: Boolean!, $spASubTotale: numeric!, $spB1Livello: Int!, $spB1_1: Boolean!, $spB1_2: Boolean!, $spB1_3: Boolean!, $spB1_4:Boolean!, $spB1Altro: Boolean!, $spB1AltroNote: String!, $spB2Livello: Int!, $spB2_1: Boolean!, $spB2_2: Boolean!, $spB2_3: Boolean!, $spB2_4: Boolean!, $spB2Altro: Boolean!, $spB2AltroNote: String!, $spB3Livello: Int!, $spB3_1: Boolean!, $spB3_2: Boolean!,$spB3_3: Boolean!, $spB3Altro: Boolean!, $spB3AltroNote: String!, $spB4Livello: Int!, $spB4_1: Boolean!, $spB4_2: Boolean!, $spB4_3: Boolean!, $spB4Altro: Boolean!, $spB4AltroNote: String!, $spB5Livello: Int!, $spB5_1: Boolean!, $spB5_2: Boolean!, $spB5_3: Boolean!, $spB5Altro: Boolean!, $spB5AltroNote: String!, $spB6Livello: Int!, $spB6_1: Boolean!, $spB6_2: Boolean!, $spB6_3: Boolean!, $spB6_4: Boolean!, $spB6Altro: Boolean!, $spB6AltroNote: String!, $spB7Livello: Int!, $spBSubTotale: numeric!, $spC1_1_Livello: Int!, $spC1_2_Livello: Int!, $spC1_3_Livello: Int!, $spCSubTotale: numeric!, $efRiTotale: numeric!, $efSpTotale: numeric!, $efTotale: numeric!, $efAdeguataLivello: Int!, $providedBy: String!, $hasTabellaB: Boolean!, $dataControlloCostante: timestamp!, $hasTitEffPep : Boolean!) {
    update_rischio(where: {Id: {_eq: $id}}, _set: {PrestazioneId: $prestazioneId, Date: $date, SpA1Livello: $spA1Livello, SpA1_1: $spA1_1, SpA1_2: $spA1_2, SpA1_3: $spA1_3, SpA1_4: $spA1_4, SpA1_5: $spA1_5, SpA1_6: $spA1_6,SpA1_7: $spA1_7, SpA1Altro: $spA1Altro, SpA1AltroNote: $spA1AltroNote, SpA2Altro: $spA2Altro, SpA2AltroNote: $spA2AltroNote, SpA2Livello: $spA2Livello, SpA2_1: $spA2_1, SpA2_2: $spA2_2, SpA2_3: $spA2_3, SpA3Altro: $spA3Altro, SpA3AltroNote: $spA3AltroNote, SpA3Livello: $spA3Livello, SpA3_1: $spA3_1, SpA3_2: $spA3_2, SpA3_3: $spA3_3, SpA3_4: $spA3_4, SpA4Altro: $spA4Altro, SpA4AltroNote: $spA4AltroNote, SpA4Livello: $spA4Livello, SpA4_1: $spA4_1, SpA4_2: $spA4_2,SpA4_3: $spA4_3, SpA4_4: $spA4_4, SpASubTotale: $spASubTotale, SpB1Livello: $spB1Livello, SpB1_1: $spB1_1, SpB1_2: $spB1_2, SpB1_3: $spB1_3, SpB1_4: $spB1_4, SpB1Altro: $spB1Altro, SpB1AltroNote: $spB1AltroNote, SpB2Livello: $spB2Livello, SpB2_1: $spB2_1, SpB2_2: $spB2_2, SpB2_3: $spB2_3, SpB2_4: $spB2_4, SpB2Altro: $spB2Altro, SpB2AltroNote: $spB2AltroNote, SpB3Livello: $spB3Livello, SpB3_1: $spB3_1, SpB3_2: $spB3_2,SpB3_3: $spB3_3, SpB3Altro: $spB3Altro, SpB3AltroNote: $spB3AltroNote, SpB4Livello: $spB4Livello, SpB4_1: $spB4_1, SpB4_2: $spB4_2,SpB4_3: $spB4_3, SpB4Altro: $spB4Altro, SpB4AltroNote: $spB4AltroNote, SpB5Livello: $spB5Livello, SpB5_1: $spB5_1, SpB5_2: $spB5_2, SpB5_3: $spB5_3, SpB5Altro: $spB5Altro, SpB5AltroNote: $spB5AltroNote, SpB6Livello: $spB6Livello, SpB6_1: $spB6_1, SpB6_2: $spB6_2, SpB6_3: $spB6_3, SpB6_4: $spB6_4, SpB6Altro: $spB6Altro, SpB6AltroNote: $spB6AltroNote, SpB7Livello: $spB7Livello, SpBSubTotale: $spBSubTotale, SpC1_1_Livello: $spC1_1_Livello, SpC1_2_Livello: $spC1_2_Livello, SpC1_3_Livello: $spC1_3_Livello, SpCSubTotale: $spCSubTotale, EfRiTotale: $efRiTotale, EfSpTotale: $efSpTotale, EfTotale: $efTotale, EfAdeguataLivello: $efAdeguataLivello, ProvidedBy: $providedBy, HasTabellaB: $hasTabellaB, DataControlloCostante: $dataControlloCostante, HasTitEffPep : $hasTitEffPep, ModifiedOn: "now()"}) {
        returning {
            Id
            PrestazioneId
            Date
            SpA1Livello
            SpA1_1
            SpA1_2
            SpA1_3
            SpA1_4
            SpA1_5
            SpA1_6
            SpA1_7
            SpA1Altro
            SpA1AltroNote
            SpA2Livello
            SpA2_1
            SpA2_2
            SpA2_3
            SpA2Altro
            SpA2AltroNote
            SpA3Livello
            SpA3_1
            SpA3_2
            SpA3_3
            SpA3_4
            SpA3Altro
            SpA3AltroNote
            SpA4Livello
            SpA4_1
            SpA4_2
            SpA4_3
            SpA4_4
            SpA4Altro
            SpA4AltroNote
            SpASubTotale
            SpB1Livello
            SpB1_1
            SpB1_2
            SpB1_3
            SpB1Altro
            SpB1AltroNote
            SpB2Livello
            SpB2_1
            SpB2_2
            SpB2_3
            SpB2_4
            SpB2Altro
            SpB2AltroNote
            SpB3Livello
            SpB3_1
            SpB3_2
            SpB3_3
            SpB3Altro
            SpB3AltroNote
            SpB4Livello
            SpB4_1
            SpB4_2
            SpB4_3
            SpB4Altro
            SpB4AltroNote
            SpB5Livello
            SpB5_1
            SpB5_2
            SpB5_3
            SpB5Altro
            SpB5AltroNote
            SpB6Livello
            SpB6_1
            SpB6_2
            SpB6_3
            SpB6_4
            SpB6Altro
            SpB6AltroNote
            SpB7Livello
            SpBSubTotale
            SpC1_1_Livello
            SpC1_2_Livello
            SpC1_3_Livello
            SpCSubTotale
            EfRiTotale
            EfSpTotale
            EfTotale
            EfAdeguataLivello
            ProvidedBy
            CreatedOn
            ModifiedOn
            HasTabellaB
            DataControlloCostante
            CreatedBy
            ModifiedBy
        }
    }
}`;
export const mutation_delete_rischio = `
mutation deleteRischio($id: Int!) {
    delete_rischio(where: {Id: {_eq: $id}}) {
        affected_rows
    }
}`;